// import React from "react";
// import {
//   LoginAFY,
//   LoginAFY2,
// } from "@affinitysystemsgroup/github-packages-affinity-components/dist";

// const Login_ah: React.FC = () => {
//   return (
//     <>
//       {/* <LoginAFY
//       onSignIn={props.onSingIn}
//       title={props.title}
//       logo={props.logo}
//       emailError={props.emailError}
//       emailRequired={props.emailRequired}
//       emailText={props.emailText}
//       emailHelperText={props.emailHelperText}
//       passwordHelperText={props.passwordHelperText}
//       passwordText={props.passwordText}
//       passwordError={props.passwordError}
//       passwordRequired={props.passwordRequired}
//       labelButtonLogin={props.labelButtonLogin}
//       labelButtonForgetPassword={props.labelButtonForgetPassword}
//       labelInputPassword={props.labelInputPassword}
//       userForm={props.userForm}
//       onClickForgetPassword={props.onClickForgetPassword}
//       showSSO={props.showSSO}
//       onSubmitSSO={props.onSubmitSSO}
//       labelButtonLoginSSO={props.labelButtonLoginSSO}

//     /> */}
//       <LoginAFY2 {...props} />
//     </>
//   );
// };

import {
  LoginAFY2,
  LgPageProps,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";

export const LoginView_ah = (props: LgPageProps) => {
  return <LoginAFY2 {...props} />;
};
